

const uuid =  () => {
  let d = new Date().getTime();//Timestamp
  let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = Math.random() * 16;//random number between 0 and 16
    if(d > 0){//Use timestamp until depleted
      r = (d + r)%16 | 0;
      d = Math.floor(d/16);
    } else {//Use microseconds since page-load if supported
      r = (d2 + r)%16 | 0;
      d2 = Math.floor(d2/16);
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

/************************************************************************************************
 * return first letter of each word limit 2
 * @param str => string
 ***********************************************************************************************/
const acrostic = (str:string) => {
  let short = '';
  if(str && str.trim().length > 1 ) {
    const section = str.trim().split(' ');
    if(section.length === 1) {
      short = section[0][0]+section[0][1];
    }
    else if(section.length > 1 && section.length < 3) {
      short = section[0][0]+section[1][0];
    } else {
      short = section[0][0]+section[section.length-1][0];
    }
  }
  return short;
}


const truncateString = (str: string, num: number) => {
  if (str.length <= num) {
    return str
  }
  return str.slice(0, num) + '...'
}

const lapsAge = (age_min:number = null, age_max:number = null) => {
  let ageLaps = '';

  if(age_min && age_max) {
    ageLaps = age_min+' ans - '+age_max+' ans';
  } else if (!age_min && age_max) {
    ageLaps = ' Jusqu\'à '+age_max+' ans';
  }  else if (age_min && !age_max) {
    ageLaps = ' A partir de '+age_min+' ans';
  }
  return ageLaps;
}


export const getLetterPosition = (letter: string) => {

}


export{uuid, acrostic, truncateString, lapsAge};










